import { on_ready } from 'src/js/utils';
import { ajax } from 'src/api/ajax';
import { create_element } from 'src/js/utils';
import { on_resize } from 'src/js/utils';
import GrabToPan from 'src/vendors/grab-to-pan/grab-to-pan';
import { add_to_cart_ajax_init } from 'src/woocommerce/js/add_to_cart';

import './compare.scss';

const no_items_message = 'Your compare list is currently empty';
const container = document.getElementById('compare_render');

let compare;

const headers = {
    image: 'Product Picture',
    title: 'Product Title',
    price: 'Product Pricing',
    description: 'Description',
    sku: 'SKU',
    tags: 'Tags',
    rating: 'Rating',
    add_to_cart_con: '',
};
const header_keys = Object.keys(headers);

on_resize(()=>{
    set_same_height();
});

on_ready(()=>{
    if( !container ) return;
    if( typeof document.body.save_items_compare === 'undefined' ) return;

    compare = document.body.save_items_compare;

    if( !compare.items.length ) {
        container.innerHTML = `<div class="no_items">${no_items_message}</div>`;
        return;
    }
    
    ajax( 'compare', { items: compare.items }, { done: (res)=>render(res) } );
});

function render(res){

    if( !res.items.length ) {
        container.innerHTML = `<div class="no_items">${no_items_message}</div>`;
        return;
    }

    const render_container = create_element({class_name: 'render_container', render: container});
    render_container.style.opacity = 0;

    // headers
    const headers_container = create_element({class_name: 'headers', render: render_container});
    header_keys.forEach(field_key=>{
        create_element({class_name: field_key + ' field', render: headers_container, text: headers[field_key]});
    })
    
    // items 
    const items_container = create_element({class_name: 'items', render: render_container});
    res.items.forEach(item=>{

        // console.log(item);

        const item_container = create_element({class_name: 'item', render: items_container});

        header_keys.forEach(field_key=>{

            const field = create_element({class_name: field_key + ' field', render: item_container});
            const field_inner = create_element({class_name: 'inner', render: field});
            let field_html = item[field_key] ?? '';

            if( field_key == 'image' ) {
                field_html = `
                <div class="image_con image_fit">
                    <a href="${item.link}">${field_html}</a>
                </div>`;
            }
            else if( field_key == 'title' ) {
                field_html = `<a href="${item.link}">${field_html}</a>`;
            }
            else if ( field_key == 'rating' ) {
                
                if( !item.rating ) {
                    field_html = '';
                }
                else {
                    const rating_percentage = (item.rating / 5) * 100;
                    field_html = `
                    <div class="custom_product_review_rating">
                        <div class="initial"></div>
                        <div class="fill" style="clip-path: polygon(0 0, ${rating_percentage}% 0, ${rating_percentage}% 100%, 0% 100%)"></div>
                    </div>
                    `;
                }
                
            }
            else if ( field_key == 'add_to_cart_con' ) { 
                if(item.is_variable ){
                    field_html = `<a href="${item.link}" class="btn secondary small view_btn">View</a>`;
                }else{
                    field_html = `<button class="add_to_cart_btn add_to_cart_ajax small" data-product_id="${item.id}">Add to Cart</button>`;
                }
                
            }

            field_inner.innerHTML = field_html;

            if( field_key == 'image' ) {
                remove_button_init(field, item.id, item_container);
            }
        })
    });

    add_to_cart_ajax_init(items_container);

    set_same_height();
    
    // show items
    setTimeout(()=>{
        render_container.style.opacity = 1;
        loading_complete();
    }, 50);

    const g2p = new GrabToPan({
        element: items_container,
    });
    g2p.activate();

    // clean_invalid_items();
}

function remove_button_init( field_container, id, item_container ){
    const remove_button = create_element({class_name: 'remove_btn', text: 'Remove', render: field_container, render_method: 'prepend'});
    remove_button.addEventListener('click', ()=>{
        remove_item(id, item_container);
    });
}

function loading_complete(){
    const spinner = container.querySelector('.spinner');
    const animation_duration = 300;
    spinner.style.transition = `all ${animation_duration}ms ease`;
    spinner.style.opacity = 0;
    spinner.style.transform = 'translateY(10px)';
    setTimeout(()=>spinner.remove(), animation_duration);
}

function clean_invalid_items(){
    let valid_item_ids = [];
    container.querySelectorAll('.item').forEach(item=>{
        let id = parseInt(item.dataset.id);
        valid_item_ids.push(id);
    })
    if( compare.items.length != valid_item_ids.length ) {
        // have invalid ids, update items
        compare.set_items(valid_item_ids);
    }
}

function remove_item(id, item){
    item.style.pointerEvents = 'none';
    item.style.opacity = 0;
    item.style.transform = 'scale(.9)';
    setTimeout(() => item.remove(), 300);
    // compare.remove_item(id);
}

function set_same_height(){
    
    const items = container.querySelectorAll('.item');
    const headers_container = container.querySelector('.headers');

    header_keys.forEach(field_key=>{

        const header_field = headers_container.querySelector('.'+ field_key)

        let tallest = 0;

        let item_fields = [];

        // set same row height for each columns - use tallest height
        items.forEach(item=>{
            const field = item.querySelector('.'+ field_key)
            item_fields.push(field);
            if( field.offsetHeight > tallest ) {
                tallest = field.offsetHeight;
            } 
        })

        // apply tallest height
        header_field.style.minHeight = tallest+'px';
        item_fields.forEach(item_field=>{
            item_field.style.minHeight = tallest+'px';
        })

    })
    
}